package com.milta.core.localization.translations.nl

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Document scannen",
    reviewTitle = "Gegevens controleren",
    fileSentSuffix = "net verzonden",
    analysingTitle = "Document wordt gelezen…",
    analysingSubtitle = "We detecteren de leveringen op de foto. Dit duurt maar een paar seconden.",
    deliveriesDetectedSuffix = "leveringen gedetecteerd",
    toCompleteSuffix = "aan te vullen",
    reviewHint = "Vul de gemarkeerde leveringen aan voordat u ze aan de rit toevoegt",
    addressMissingWarning = "Adres ontbreekt",
    nameMissingWarning = "Naam ontbreekt",
    recipientMissingPlaceholder = "Geen ontvanger gedetecteerd",
    phoneNotDetectedNote = "Telefoon niet gedetecteerd — toevoegen niet geblokkeerd",
    deadlineLabelPrefix = "Uiterste tijd",
    completeLinkLabel = "Aanvullen",
    addToRouteButtonPrefix = "Toevoegen aan de rit",
    correctionRecipientLabel = "Ontvanger",
    correctionAddressLabel = "Adres",
    correctionPhoneLabel = "Telefoon",
    correctionDeadlineLabel = "Uiterste tijd",
    attemptLabel = "Poging",
    unreadableTitle = "Foto onleesbaar.",
    unreadableMessage = "We hebben geen enkele levering op deze afbeelding gedetecteerd — maak een nieuwe, goed gekaderde en goed belichte foto.",
    retakePhotoButton = "Nieuwe foto maken",
    manualEntryButton = "Handmatig invoeren",
    maxAttemptsTitle = "Nog steeds onleesbaar na 2 pogingen.",
    maxAttemptsMessage = "Vul deze levering handmatig aan, of start de scan opnieuw met een nieuw document.",
    retakeUnavailableLabel = "Nieuwe foto maken — niet beschikbaar",
    rateLimitTitle = "Onlangs te veel scans uitgevoerd.",
    rateLimitMessage = "Probeer het later opnieuw, of vul deze levering ondertussen handmatig aan.",
    rateLimitRetakeUnavailableLabel = "Nieuwe foto maken — momenteel niet beschikbaar",
)
